import { useState, useEffect, useCallback } from "react";
import { fetchSelectedContestDetails } from "../../../utils/api";

const useFetchContestDetails = (id) => {
  const [contest, setContest] = useState(null);
  const [loading, setLoading] = useState(true); // Add loading state
  const [error, setError] = useState(null); // Add error state

  const fetchData = useCallback(async () => {
    // Basic validation: Check if ID exists and is not one of the routing keywords
    const invalidIds = ["registering", "running", "completed", undefined, null];
    if (id && !invalidIds.includes(id)) {
      setLoading(true);
      setError(null); // Clear previous errors
      try {
        const contestData = await fetchSelectedContestDetails(id);
        setContest(contestData);
      } catch (error) {
        setError(error.message || 'Failed to fetch contest details');
        setContest(null);
      } finally {
        setLoading(false);
      }
    } else {
      setContest(null);
      setError(`Invalid or missing contest ID: ${id}`);
      setLoading(false);
    }
  }, [id]); // Dependency: id, as refetching with a new ID should use the new ID

  useEffect(() => {
    fetchData();
  }, [fetchData]); // Call fetchData when it (or its dependency 'id') changes

  // Return an object including loading, error states, and the refetch function
  return { contest, loading, error, refetch: fetchData };
};

export default useFetchContestDetails;
